import {GET_STAFF_SURVEYS_RESPONSES} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";

export default {
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            selectedEmployees: [],
            isContextMenuOpen: false,
            options: {
                showSearch: true,
                showFilter: true,
                name: this.$allLabel('surveyDetails'),
                url: `${GET_STAFF_SURVEYS_RESPONSES}/${this.getIdFromUrl()}`,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                rowLimit: 10,
                paginationType: "pagination",
                columns: [
                    {
                        title: this.$t('survey'),
                        type: 'custom-html',
                        key: 'survey',
                        isVisible: true,
                        modifier: survey => survey.title
                    },
                    {
                        title: this.$t('response_title'),
                        type: 'custom-html',
                        key: 'response_text',
                        isVisible: true,
                        modifier: response_text => response_text
                    },
                    {
                        title: this.$t('response'),
                        type: 'custom-html',
                        key: 'emoji_icon',
                        isVisible: true,
                        modifier: emoji_icon => (emoji_icon ? emoji_icon : '-'),
                    },
                    {
                        title: this.$t('created_at'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: created_at => {
                            if (!created_at) return '';
                            const date = new Date(created_at);
                            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
                        }
                    },
                    {
                        title: this.$t('user'),
                        type: 'custom-html',
                        key: 'user',
                        modifier: user => `${user?.first_name} ${user?.last_name}` ?? '',
                    },
                ],
                actions: [
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"],
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ],
            },
        };
    },
    props: {
    },
    created() {
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        getIdFromUrl() {
            const params = new URLSearchParams(window.location.search);
            return params.get('id') || ''; // Fallback to an empty string if 'id' is not present
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range !== 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range);
            }
            this.$store.dispatch('updateFilterObject', filterValue);
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', { search });
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {
            switch (action.key) {
                case 'edit':
                    this.isModalActive = true;
                    this.selectedUrl = `${GET_STAFF_SURVEYS_RESPONSES}/${row.id}/edit`;
                    break;
                case 'view_details':
                    window.location.href = `${action.url}/${row.id}`;
                    break;
                default:
                    this.getAction(row, action, active);
            }
        },
        reloadSurveyTable() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('reload-surveys-table');
        },
    },
};
